import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import AboutSection from '../components/about/AboutSection';
import ValuesSection from '../components/about/ValuesSection';
import { AboutSEO } from '../components/layout/SEO';
import { usePageData } from '../contexts/DataContext';

const AboutPage = () => {
  const { data: aboutPage } = usePageData('aboutPage');


  return (
    <HelmetProvider>
      <div className="about-page">
        <AboutSEO pageData={aboutPage} />
        <AboutSection />
        <ValuesSection />
      </div>
    </HelmetProvider>
  );
};

export default AboutPage;
